// ChannelMentionAutocomplete.jsx

import React from 'react';

// Context
import { useTheme } from 'context/ThemeContext';

// CSS
import './ChannelMentionAutocomplete.css';

// Components
import ProfilePhoto from 'components/profilephoto/ProfilePhoto';

/**
 * ChannelMentionAutocomplete
 *
 * Renders mention suggestions for the channel composer.
 *
 * @returns {ReactNode} The rendered component.
 */
const ChannelMentionAutocomplete = React.memo(({
  candidates = [],
  activeIndex = 0,
  onSelect,
}) => {

  // ----- CONTEXT ----- //

  const { theme } = useTheme();

  if (!candidates.length) return null;

  // ----- RENDER ----- //

  return (
    <div
      className="channel-mention-autocomplete"
      role="listbox"
      aria-label="Mention suggestions"
    >
      {candidates.map((candidate, index) => {
        const isActive = index === activeIndex;

        return (
          <button
            className={`channel-mention-autocomplete-row${isActive ? ' is-active' : ''}`}
            style={{
              backgroundColor: isActive ? theme.input : 'transparent',
            }}
            key={candidate.userKey}
            type="button"
            role="option"
            aria-selected={isActive}
            onMouseDown={(event) => {
              event.preventDefault();
              onSelect?.(candidate);
            }}
          >

            {/* AVATAR */}
            <span className="channel-mention-autocomplete-avatar">
              <ProfilePhoto
                node={candidate.avatarNode}
                size={24}
              />
            </span>

            {/* META */}
            <span className="channel-mention-autocomplete-meta">

              {/* NAME */}
              <span className="channel-mention-autocomplete-name">
                {candidate.name}
              </span>

              {/* NOTE */}
              {candidate.kind === 'mentioned' ? (
                <span
                  className="channel-mention-autocomplete-note"
                >
                  Mentioned
                </span>
              ) : !candidate.inChannel ? (
                <span
                  className="channel-mention-autocomplete-note"
                >
                  Not in channel
                </span>
              ) : null}
            </span>
          </button>
        );
      })}
    </div>
  );
});

// Dev Tools
ChannelMentionAutocomplete.displayName = 'ChannelMentionAutocomplete';

export default ChannelMentionAutocomplete;
